export const US_PHONE_PATTERN = /\+1\D*([2-9]\d{2})\D*(\d{3})\D*(\d{4})(?!\d)/;
